// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/herzlichen-glueckwunsch-zur-berufsausbildung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const herzlichenGlueckwunschZurBerufsausbildungDE: PageEntry = {
  id: "post.herzlichen-glueckwunsch-zur-berufsausbildung",
  locale: "de",
  slug: "herzlichen-glueckwunsch-zur-berufsausbildung",
  seo: {
    title: "Herzlichen Glückwunsch zur Berufsausbildung! | Dietz GmbH",
    description: "Herzlichen Glückwunsch zur Berufsausbildung!",
  },
  type: "post",
  h1: "Herzlichen Glückwunsch zur Berufsausbildung!",
  blocks: [
    { kind: "heading", level: 2, text: "Herzlichen Glückwunsch zur Berufsausbildung!" },
    { kind: "heading", level: 3, text: "Internes" },
    { kind: "paragraph", text: "Fünf Auszubildende haben im Februar ihre Lehre bei DIETZ abgeschlossen. Lukas Radtke und Lenina Fiedler aus der Schenkel-Federnabteilung, Maximilian Rölke-Ehrlicher aus dem Qualitätsmanagement, Daniel Schnetter aus der Abteilung Druckfedern groß und Mavin Schilling, der im Werbkzeugbau zum CNC-Fräser ausgebildet wurde. Die frisch gebackenen Gesellen dü rfen sich über gute Noten mit einem Durchschnitt zwischen 1,6 und 2,6 freuen und wurden alle von DIETZ übernommen. Wir freuen uns über den Fachkräftenachwuchs in den eigenen Reihen und wünschen allen einen guten Start in ihr weiteres Berufsleben!" },
    { kind: "paragraph", text: "Die DIETZ-Durchstarter v.l.n.r.: Daniel Schnetter, Marvin Schilling, Maximilian Rölke-Ehrlicher, Lenina Fiedler und Lukas Radtke" }
  ],
};
